import { Group } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { ArtiLogo } from "../../components/arti-logo/arti-logo";

export const Introduction = () => {
    useTranslation();
    return (
        <>
            <Group gap="sm" justify="center" align="center" flex={{ grow: 1 }}>
                <Group align="center" w={{ base: 250, sm: 400, lg: 450 }}>
                    <ArtiLogo />
                </Group>
            </Group>
        </>
    );
};
